import FileDownload from "js-file-download";
import { 
  getAccessHistory, 
  getAccessPages, 
  getMFA, 
  getCompanyAndPolicy, 
  getLastLogin, 
  exportAccessHistoryData 
} from "@/api/ppanalytic.api";
import { startOfDay } from "date-fns";

const fn = {
  SET_TABLE_DATA: "SET_TABLE_DATA",
  SET_PAGES: "SET_PAGES",
  SET_MFA: "SET_MFA",
  SET_TOTAL_DATA: "SET_TOTAL_DATA",
  SET_ISMFA_NOT_READY: "SET_ISMFA_NOT_READY",
  SET_ISMFA_READY: "SET_ISMFA_READY",
  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
  RESET_DATA: "RESET_DATA",
  SET_COMPANY: "SET_COMPANY",
  SET_LAST_LOGIN_DATA: "SET_LAST_LOGIN_DATA",
  SET_FILTERS: "SET_FILTERS",
  RESET: "RESET"
};

const initialState = () => ({
  filters:{},
  tabledata: [],
  totalData: 0,
  currentPage: 1,
  pages: [{ page: "All", display_page: "All Pages" }],
  isMfaReady: false,
  mfa: {},
  company: [],
  last_login_data: [],
  loading: false,
});

const state = initialState();

const getters = {
  getTableData: state => state.tabledata,
  getPages: state => state.pages,
  getMFA: state => state.mfa,
  getTotalData: state => state.totalData,
  getIsMFAReady: state => state.isMfaReady,
  getCurrentPage: state => state.currentPage,
  getCompany: state => state.company,
  getLogin: state => state.last_login_data,
  getLoading: state => state.loading
};

// actions
const actions = {
  reset({ commit }) {
    commit(fn.RESET);
  },
  async getAccessHistoryData({ commit }, payload) {
    try {
      const resp = await getAccessHistory(payload);
      if (resp.data) {
        commit(fn.SET_FILTERS, payload);
        commit(fn.SET_TABLE_DATA, resp.data.data);
        commit(fn.SET_TOTAL_DATA, resp.data.data.total);
        commit(fn.SET_CURRENT_PAGE, resp.data.data.current_page);
      }
    } catch (err) {
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async exportAccessHistoryData({ commit, state }) {
    try {
      // commit(fn.SET_LOADING, true);
      let resp;
      resp = await exportAccessHistoryData(state.filters);
      if (resp.data) {
        FileDownload(resp.data, "access_history.xlsx");
        // commit(fn.SET_LOADING, false);
      }
    } catch (err) {
      // commit(fn.SET_LOADING, false);
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async getPagesData({ commit }) {
    try {
      const response = await getAccessPages();
      if (response.data) {
        commit(fn.SET_PAGES, response.data.pages);
      }
    } catch (error) {
      console.log(error);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async getMfaData({ commit }) {
    try {
      commit(fn.SET_ISMFA_NOT_READY);

      const response = await getMFA();

      if (response.data) {
        commit(fn.SET_MFA, response.data.mfa);
        commit(fn.SET_ISMFA_READY);
      }
    } catch (error) {
      console.log(error);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async getCompanyData({ commit }) {
    try {
      const resp = await getCompanyAndPolicy();
      if (resp.data) {
        let company = resp.data.company;
        company.unshift({ id: 0, name: "All" });
        commit(fn.SET_COMPANY, company);
        // commit(fn.SET_COMPANY, resp.data.company);
        // commit(fn.SET_POLICY, resp.data.policy);
      }
    } catch (err) {
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async getLastLoginData({ commit }, payload) {
    try {
      const resp = await getLastLogin(payload);
      if (resp.data) {
        commit(fn.SET_LAST_LOGIN_DATA, resp.data.data);
        commit(fn.SET_TABLE_DATA, resp.data.data);
        commit(fn.SET_TOTAL_DATA, resp.data.data.total);
        commit(fn.SET_CURRENT_PAGE, resp.data.data.current_page);
      }
    } catch (err) {
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async resetData({ commit }) {
    try {
      commit(fn.RESET_DATA);
    } catch (error) {
      console.log(error);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  }
};

// mutations
const mutations = {
  [fn.SET_TABLE_DATA](state, payload) {
    state.tabledata = payload;
  },
  [fn.SET_PAGES](state, payload) {
    state.pages = [...state.pages, ...payload];
  },
  [fn.SET_MFA](state, payload) {
    Object.assign(state.mfa, payload);
  },
  [fn.SET_TOTAL_DATA](state, payload) {
    state.totalData = payload;
  },
  [fn.SET_CURRENT_PAGE](state, payload) {
    state.currentPage = payload;
  },
  [fn.SET_ISMFA_NOT_READY](state) {
    state.isMfaReady = false;
  },
  [fn.SET_ISMFA_READY](state) {
    state.isMfaReady = true;
  },
  [fn.SET_COMPANY](state, payload) {
    state.company = payload;
  },
  [fn.SET_LAST_LOGIN_DATA](state, payload) {
    state.last_login_data = payload;
  },
  [fn.SET_FILTERS](state, payload) {
    state.filters = payload;
  },
  [fn.RESET_DATA](state) {
    state.tabledata = [];
    state.totalData = 0;
    state.currentPage = 1;
    state.pages = [{ page: "All", display_page: "All Pages" }];
    state.isMfaReady = false;
    state.mfa = {};
  },
  [fn.RESET](state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  [fn.SET_LOADING](state, payload) {
    state.loading = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
